interface ProgressBarProps {
  value: number;
  max?: number;
  showLabel?: boolean;
}

export function ProgressBar({ value, max = 100, showLabel = false }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="stack" style={{ gap: 6 }}>
      <div className="issue-progress" style={{ height: 4 }}>
        <div className="issue-progress__bar" style={{ width: `${pct}%` }} />
      </div>
      {showLabel && (
        <div className="row-s t-mono" style={{ fontSize: 11, color: "var(--text-muted)" }}>
          <span>{value} / {max}</span>
          <span>{Math.round(pct)}%</span>
        </div>
      )}
    </div>
  );
}
